;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { useMemo, useState, type ChangeEvent, type ComponentProps } from 'react'

import { Input } from '@/components/ui/input'

type WorkspaceInputProps = Omit<ComponentProps<typeof Input>, 'type' | 'className'> & {
  domain: string
}

export function WorkspaceInput({
  domain,
  value,
  defaultValue,
  onChange,
  'aria-invalid': ariaInvalid,
  ...props
}: WorkspaceInputProps) {
  const normalizedDomain = useMemo(() => {
    const sanitized = domain.trim().replace(/^\./, '')
    return `.${sanitized}`
  }, [domain])

  const normalize = useMemo(
    () => (input: string) => {
      if (!input) return ''

      const withoutSuffix = input.endsWith(normalizedDomain) ? input.slice(0, -normalizedDomain.length) : input

      return withoutSuffix
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+/, '')
    },
    [normalizedDomain],
  )

  const externalValue = typeof value === 'string' ? normalize(value) : undefined
  const [internalValue, setInternalValue] = useState(() =>
    typeof defaultValue === 'string' ? normalize(defaultValue) : '',
  )
  const currentValue = externalValue ?? internalValue
  const hasValue = currentValue.trim().length > 0

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = normalize(event.currentTarget.value)
    event.currentTarget.value = nextValue
    if (externalValue === undefined) {
      setInternalValue(nextValue)
    }
    onChange?.(event)
  }

  return (
    <div data-slot="control" className="relative">
      <Input
        {...props}
        value={currentValue}
        defaultValue={undefined}
        onChange={handleChange}
        aria-invalid={ariaInvalid}
        className="[&_input]:pr-36"
      />
      <span
        className={`pointer-events-none absolute inset-y-0 left-4 flex items-center text-sm/7 transition-opacity ${
          hasValue ? 'opacity-100' : 'opacity-0'
        }`}
        aria-hidden="true"
      >
        <span className="invisible whitespace-pre">{currentValue}</span>
        <span className="ml-px font-light text-mist-600 dark:text-mist-300">{normalizedDomain}</span>
      </span>
    </div>
  )
}
